import { render, staticRenderFns } from "./main.establecimientos-comercio.vue?vue&type=template&id=65f7a746"
import script from "./main.establecimientos-comercio.vue?vue&type=script&lang=js"
export * from "./main.establecimientos-comercio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports